import React from 'react';
import AppRouter from '@shared/navigation/AppRouter';
import { Route } from 'react-router-dom';
import PaymentLink from '../pages/PaymentLink';
import Packages from '../pages/Packages';
import { PACKAGES, PAYMENTS } from '@shared/helpers/routes';

export default () => {
  return (
    <AppRouter
      childrenNoLayout={
        <Route exact path={PAYMENTS}>
          <PaymentLink />
        </Route>
      }
    >
      <Route exact path={PACKAGES}>
        <Packages />
      </Route>
    </AppRouter>
  );
};
